(function () {
  if (window.__designNahledyAjaxBound) return;
  window.__designNahledyAjaxBound = true;

  var loading = false;
  var sectionCache = Object.create(null);
  var prefetchInflight = Object.create(null);
  function showError(root, message) {
    var el = root && root.querySelector('[data-design-nahledy-error]');
    if (!el) {
      console.error(message);
      return;
    }
    el.hidden = false;
    el.textContent = message;
  }

  function clearError(root) {
    var el = root && root.querySelector('[data-design-nahledy-error]');
    if (el) {
      el.hidden = true;
      el.textContent = '';
    }
  }

  function unloadSection(sectionId) {
    var instances =
      window.Shopify &&
      window.Shopify.theme &&
      window.Shopify.theme.sections &&
      window.Shopify.theme.sections.instances;
    if (!instances) return;
    for (var i = instances.length - 1; i >= 0; i -= 1) {
      if (String(instances[i].id) === String(sectionId)) {
        try {
          instances[i].onUnload();
        } catch (err) {
          console.error('design-nahledy unload', err);
        }
        instances.splice(i, 1);
      }
    }
  }

  function loadSection(container) {
    var type = container.getAttribute('data-section-type');
    var registered =
      window.Shopify &&
      window.Shopify.theme &&
      window.Shopify.theme.sections &&
      window.Shopify.theme.sections.registered &&
      window.Shopify.theme.sections.registered[type];
    if (!registered) {
      throw new Error('design-nahledy: theme section type „' + type + '“ není registrovaný.');
    }
    var section = {
      container: container,
      id: container.getAttribute('data-section-id'),
      type: registered.type,
      callStack: registered.getStack(),
      callFunctions: function (key, e) {
        var self = this;
        this.callStack[key].forEach(function (func) {
          var props = { id: self.id, type: self.type, container: self.container };
          if (e) func.call(props, e);
          else func.call(props);
        });
      },
      onLoad: function () {
        this.callFunctions('onLoad');
      },
      onUnload: function () {
        this.callFunctions('onUnload');
      },
    };
    section.onLoad();
    window.Shopify.theme.sections.instances.push(section);
  }

  function productPathFromUrl(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.pathname;
  }

  function appendQueryParams(url, params) {
    var u = new URL(url, window.location.origin);
    Object.keys(params).forEach(function (key) {
      if (params[key] != null && params[key] !== '') {
        u.searchParams.set(key, params[key]);
      }
    });
    return u.pathname + u.search;
  }

  function buildNextUrl(productUrl) {
    var params = {};
    var current = new URL(window.location.href);
    var preview = current.searchParams.get('preview_theme_id');
    if (preview) params.preview_theme_id = preview;
    var view = current.searchParams.get('view');
    if (view) params.view = view;
    if (Object.keys(params).length === 0) {
      return productPathFromUrl(productUrl) + (productUrl.indexOf('?') >= 0 ? productUrl.slice(productUrl.indexOf('?')) : '');
    }
    return appendQueryParams(productUrl, params);
  }

  function buildSectionFetchUrl(productUrl, sectionId) {
    var path = productPathFromUrl(productUrl);
    var params = { sections: sectionId };
    var current = new URL(window.location.href);
    var preview = current.searchParams.get('preview_theme_id');
    if (preview) params.preview_theme_id = preview;
    var view = current.searchParams.get('view');
    if (view) params.view = view;
    return appendQueryParams(path, params);
  }

  function hardNavigate(url) {
    window.location.assign(url);
  }

  function waitMs(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  /**
   * AOS fade/hero jen na prvním full load detailu.
   * Po AJAX výměně attribute sundáme, ať theme znovu neanimuje tlačítka/bloky.
   */
  function stripAosForAjaxSwap(root) {
    root.querySelectorAll('*').forEach(function (el) {
      var attrs = Array.prototype.slice.call(el.attributes || []);
      var removed = false;
      attrs.forEach(function (attr) {
        if (attr.name === 'data-aos' || attr.name.indexOf('data-aos-') === 0) {
          el.removeAttribute(attr.name);
          removed = true;
        }
      });
      if (removed) {
        el.classList.remove('aos-animate');
      }
    });
  }

  function prepareIncomingProductRoot(root) {
    stripAosForAjaxSwap(root);
    root.querySelectorAll('.is-loading').forEach(function (el) {
      el.classList.remove('is-loading');
    });
    root.classList.add('img-in');
    root.classList.add('design-nahledy-no-aos');
  }

  function revealSwappedSection(shopifySection, container) {
    if (!container) {
      throw new Error('design-nahledy: revealSwappedSection bez containeru.');
    }

    prepareIncomingProductRoot(container);

    shopifySection.dispatchEvent(
      new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: {
          sectionId: container.getAttribute('data-section-id'),
        },
      })
    );

    window.dispatchEvent(new Event('resize'));
  }

  function syncDocumentIdentity(shopifySection, nextUrl) {
    var titleEl = shopifySection.querySelector('.product__title, h1');
    if (titleEl && titleEl.textContent) {
      var nextTitle = titleEl.textContent.trim();
      var suffixMatch = document.title.match(/\s+[–\-|].*$/);
      document.title = nextTitle + (suffixMatch ? suffixMatch[0] : '');
      if (nextTitle) {
        document.body.id = nextTitle
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }
    }

    var path = productPathFromUrl(nextUrl);
    var handleMatch = path.match(/\/products\/([^/?#]+)/);
    if (handleMatch && handleMatch[1]) {
      document.body.setAttribute('data-product-handle', handleMatch[1]);
    }
  }

  function beginSectionSwap(shopifySection) {
    var scrollY = window.scrollY;
    var height = shopifySection.offsetHeight;
    shopifySection.style.minHeight = height + 'px';
    shopifySection.classList.add('design-nahledy-section--swap');
    return { scrollY: scrollY };
  }

  function finishSectionSwap(shopifySection, swapState) {
    window.scrollTo(0, swapState.scrollY);
    return waitMs(0).then(function () {
      shopifySection.classList.remove('design-nahledy-section--swap');
      shopifySection.style.minHeight = '';
    });
  }

  function requestSectionData(productUrl, sectionId) {
    var fetchUrl = buildSectionFetchUrl(productUrl, sectionId);
    if (sectionCache[fetchUrl]) {
      return Promise.resolve(sectionCache[fetchUrl]);
    }
    if (prefetchInflight[fetchUrl]) {
      return prefetchInflight[fetchUrl];
    }

    prefetchInflight[fetchUrl] = fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('design-nahledy: fetch selhal HTTP ' + response.status + ' pro ' + fetchUrl);
        }
        return response.json();
      })
      .then(function (data) {
        sectionCache[fetchUrl] = data;
        delete prefetchInflight[fetchUrl];
        return data;
      })
      .catch(function (err) {
        delete prefetchInflight[fetchUrl];
        throw err;
      });

    return prefetchInflight[fetchUrl];
  }

  function prefetchFromLink(root, link) {
    if (!root || !link) return;
    if (link.classList.contains('is-active') || link.getAttribute('aria-current') === 'page') {
      return;
    }
    var sectionId = root.getAttribute('data-section-id');
    var productUrl = link.getAttribute('data-url') || link.getAttribute('href');
    if (!sectionId || !productUrl) return;
    requestSectionData(productUrl, sectionId).catch(function (err) {
      console.error(err && err.message ? err.message : String(err));
    });
  }

  function switchProduct(root, link) {
    if (loading) return;
    if (link.classList.contains('is-active') || link.getAttribute('aria-current') === 'page') {
      return;
    }

    var sectionId = root.getAttribute('data-section-id');
    var productUrl = link.getAttribute('data-url') || link.getAttribute('href');
    if (!sectionId) {
      showError(root, 'design-nahledy: chybí data-section-id pro AJAX přepnutí.');
      return;
    }
    if (!productUrl) {
      showError(root, 'design-nahledy: chybí URL cílového produktu.');
      return;
    }

    var shopifySection = document.getElementById('shopify-section-' + sectionId);
    if (!shopifySection) {
      showError(root, 'design-nahledy: nenašel se #shopify-section-' + sectionId + '.');
      return;
    }

    var nextUrl = buildNextUrl(productUrl);
    clearError(root);
    loading = true;
    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');

    var swapState = beginSectionSwap(shopifySection);

    requestSectionData(productUrl, sectionId)
      .then(function (data) {
        var html = data[sectionId];
        if (!html) {
          var keys = data && typeof data === 'object' ? Object.keys(data).join(', ') : String(data);
          throw new Error(
            'design-nahledy: Section Rendering nevrátil HTML pro section „' +
              sectionId +
              '“. Klíče: [' +
              keys +
              '].'
          );
        }

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newSection =
          doc.getElementById('shopify-section-' + sectionId) ||
          doc.querySelector('.shopify-section') ||
          doc.body.firstElementChild;
        if (!newSection) {
          throw new Error('design-nahledy: v odpovědi chybí shopify-section markup.');
        }

        var newProductRoot = newSection.querySelector('[data-section-type="product-template"]');
        var oldProductRoot = shopifySection.querySelector('[data-section-type="product-template"]');
        if (!newProductRoot || !oldProductRoot) {
          throw new Error('design-nahledy: chybí [data-section-type="product-template"].');
        }

        prepareIncomingProductRoot(newProductRoot);
        unloadSection(sectionId);

        var imported = document.importNode(newProductRoot, true);
        oldProductRoot.replaceWith(imported);

        var nextContainer = shopifySection.querySelector('[data-section-type="product-template"]');
        if (!nextContainer) {
          throw new Error('design-nahledy: po výměně chybí product-template container.');
        }
        if (!nextContainer.querySelector('[data-product], .product-single__details, .form__wrapper')) {
          throw new Error('design-nahledy: po výměně je product section prázdná.');
        }

        try {
          loadSection(nextContainer);
        } catch (loadErr) {
          console.error(loadErr);
          hardNavigate(nextUrl);
          return null;
        }

        revealSwappedSection(shopifySection, nextContainer);
        syncDocumentIdentity(shopifySection, nextUrl);

        if (window.history && window.history.pushState) {
          window.history.pushState({ designNahledy: true }, '', nextUrl);
        }

        document.dispatchEvent(
          new CustomEvent('theme:design-nahledy:switched', {
            bubbles: true,
            detail: {
              sectionId: sectionId,
              url: nextUrl,
              handle: link.getAttribute('data-handle'),
            },
          })
        );

        return finishSectionSwap(shopifySection, swapState);
      })
      .catch(function (err) {
        var message = err && err.message ? err.message : String(err);
        console.error(message);
        hardNavigate(nextUrl);
      })
      .finally(function () {
        loading = false;
        var freshRoot = document.querySelector('[data-design-nahledy-root]');
        if (freshRoot) {
          freshRoot.classList.remove('is-loading');
          freshRoot.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-design-nahledy-link]');
    if (!link) return;
    var root = link.closest('[data-design-nahledy-root]');
    if (!root) return;

    event.preventDefault();
    switchProduct(root, link);
  });

  document.addEventListener('pointerenter', function (event) {
    var link = event.target.closest('[data-design-nahledy-link]');
    if (!link) return;
    var root = link.closest('[data-design-nahledy-root]');
    if (!root) return;
    prefetchFromLink(root, link);
  }, true);

  document.addEventListener('focusin', function (event) {
    var link = event.target.closest('[data-design-nahledy-link]');
    if (!link) return;
    var root = link.closest('[data-design-nahledy-root]');
    if (!root) return;
    prefetchFromLink(root, link);
  });

  window.addEventListener('popstate', function (event) {
    if (!event.state || !event.state.designNahledy) return;
    window.location.reload();
  });

  function renderItemMedia(item, active) {
    var staticUrl = item.getAttribute('data-static-url');
    var loopUrl = item.getAttribute('data-loop-url');
    var loopKind = item.getAttribute('data-loop-kind');
    var alt = item.getAttribute('aria-label') || '';
    var html;

    if (active && loopUrl) {
      if (loopKind === 'video') {
        html =
          '<video class="design-nahledy__media design-nahledy__media--loop" src="' +
          loopUrl +
          '" autoplay muted loop playsinline></video>';
      } else {
        html =
          '<img class="design-nahledy__media design-nahledy__media--loop" src="' +
          loopUrl +
          '" alt="' +
          alt.replace(/"/g, '&quot;') +
          '" width="' +
          item.clientWidth +
          '" height="' +
          item.clientHeight +
          '">';
      }
    } else if (staticUrl) {
      html =
        '<img class="design-nahledy__media" src="' +
        staticUrl +
        '" alt="' +
        alt.replace(/"/g, '&quot;') +
        '" loading="lazy">';
    } else {
      throw new Error('design-nahledy: item bez data-static-url (match=' + (item.getAttribute('data-design-match-key') || '') + ').');
    }

    item.innerHTML = html;
  }

  function setActiveOptionItem(root, activeItem) {
    var items = root.querySelectorAll('.design-nahledy__item[data-design-match-key]');
    items.forEach(function (item) {
      var active = item === activeItem;
      item.classList.toggle('is-active', active);
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
      renderItemMedia(item, active);
    });
  }

  document.addEventListener('click', function (event) {
    var item = event.target.closest('.design-nahledy__item[data-design-match-key]');
    if (!item) return;
    var root = item.closest('.design-nahledy');
    if (!root) return;
    if (item.hasAttribute('data-design-nahledy-link')) return;
    setActiveOptionItem(root, item);
  });
})();
